import { authStore } from "@/store/auth"
import { useFeatureFlagEnabled } from "posthog-js/react"

/**
 * Resolve a feature flag from the user payload served by the backend.
 *
 * Backend resolution is "admin OR PostHog": the `/auth/users/me` response
 * already contains the final boolean per flag, computed server-side. When the
 * flag is missing from the payload (e.g. user not authenticated yet) we fall
 * back to the PostHog client so the legacy targeting still works.
 *
 * Security note: this is a UI hint only. Every action gated by a flag is
 * re-checked on the backend with the JWT-derived organization_id.
 */
export function useTypedFeatureFlag(key: string, defaultValue: boolean): boolean {
  const flags = authStore(state => state.user?.feature_flags)
  const posthogValue = useFeatureFlagEnabled(key)

  if (flags && key in flags) return flags[key]

  if (posthogValue === undefined) return defaultValue

  return posthogValue
}
